/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type UserFragmentFragment = { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null };

export const UserFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment userFragment on user {
  id
  first_name
  last_name
  auth_provider_avatar_url
  default_avatar {
    domain
    path
  }
}
    `;